import { watchSteps } from "@/mocks/nanny";

export default function ViewingGuide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-4">
              <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Guide</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">观看指南</h2>
              <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                面对三个版本，很多人第一反应是「先看哪个」。其实只要按下面四步确认自己的时间与设备，选择就会清楚很多。
              </p>
              <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
                <div className="flex items-center gap-2 text-secondary-800 font-medium">
                  <i className="ri-lightbulb-flash-line text-lg"></i>
                  小提示
                </div>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                  三个版本彼此独立、并非删减关系，先看哪一版都不会「剧透」其余版本的关键体验。
                </p>
              </div>
            </div>

            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {watchSteps.map((step, i) => (
                <div key={step.title} className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
                  <div className="flex items-center justify-between">
                    <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className={`${step.icon} text-xl`}></i>
                    </span>
                    <span className="font-heading text-3xl md:text-4xl font-bold text-background-300">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
                  <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}